import { AfterContentInit, ChangeDetectorRef, Directive, ElementRef, Input, input } from "@angular/core";

@Directive({
    selector: "[pgh-autofocus]",
    standalone: true
})
export class AutofocusDirective implements AfterContentInit {
    private focus = true;

    readonly inputId = input<string>('');
    @Input() set autofocus(condition: boolean) {
        this.focus = condition !== false;
    }

    constructor(private el: ElementRef, private cdr: ChangeDetectorRef) { }

    ngAfterContentInit() {
        if (this.focus) {
            //The setTimeout is to avoid angular error: Expression has changed after it was checked.
            window.setTimeout(() => {
                this.cdr.detectChanges();
                const inputId = this.inputId();
                if (inputId) {
                    const id = '#'+inputId;
                    this.el.nativeElement.querySelector(id).focus();
                } else {
                    this.el.nativeElement.focus();
                }
            });
        }        
    }
}